jQuery.validator.addMethod("phonePrefix", function(value, element) {
    return /^(\+)[0-9]{2,3}$/.test(value) || value == "";
}, jQuery.validator.format("Please enter valid phone prefix."));

$(function() {
    $('.js-trigger-wishlist-clear').on('click', function(e) {
        e.preventDefault();

        let title = $(this).data('alert-title');

        Eshop.confirm(title, {}, function () {
            $('form[name="js-form-wishlist-clear"]').submit();
        });
    });

    $('.js-wishlist-delete').on('click', function(e) {
        e.preventDefault();

        let title = $(this).data('alert-title'),
            url = $(this).attr('href');

        Eshop.confirm(title, {}, function () {
            location.href = url;
        });
    });

    // $('.js-custom-phone-number').each(function() {
    //     const message = $(this).data('exactlength-error') || 'Zadajte hodnotu s dĺžkou {0} znakov, napr.: 944003302';

    //     $(this).rules('add', {
    //         exactlength: 9,
    //         messages: {
    //             exactlength: jQuery.validator.format(message)
    //         }
    //     });

    //     $(this).rules('remove', 'phone');
    // });

    $('.js-custom-phone-prefix, .js-custom-phone-number').on('blur, change', function () {
        const $form = $(this).closest('form');
        const iterator = $(this).data('iterator');
        const prefix = $form.find('[name="customer_addresses[' + iterator + '][custom_prefix]"]').val();
        const phone_number = $form.find('[name="customer_addresses[' + iterator + '][phone_number]"]').val();

        $('[name="customer_addresses[' + iterator + '][phone]"]').prop('value', prefix + phone_number);
    });
});
